import React from "react";
import ReactiveComponent from "@usereactify/search-internals/lib/components/basic/ReactiveComponent";

import { useFlags, useReactifySearchContext } from "../../hooks";
import { getPropsSensorInventoryAvailable } from "../../utility/props";

export const SensorInventoryAvailable: React.FC = () => {
  const flagsHook = useFlags();
  
  const reactifySearchContext = useReactifySearchContext();
  const reactiveProps = getPropsSensorInventoryAvailable({
    config: reactifySearchContext.config,
    provider: reactifySearchContext.options,
  });

  if (!reactiveProps) {
    return null;
  }

  if (!flagsHook.flags["reactify-search:flag_sensor_inventoryavailable"]) {
    return null;
  }

  return (
    <ReactiveComponent
      {...reactiveProps}
    />
  );
};
